import theme from 'shared/presentation/styles/settings/theme.style'

import {
  ButtonProps,
  Text,
  NativeSyntheticEvent,
  NativeTouchEvent,
  StyleProp,
  ViewStyle,
} from 'react-native'
import styled from 'styled-components/native'

type CustomProps = {
  color?: string
  textColor?: string
  disabled?: boolean
  flat?: boolean
  style?: StyleProp<ViewStyle>
}

type Props = ButtonProps & CustomProps

const ButtonAtom = (props: Props) => {
  const onPress = (ev: NativeSyntheticEvent<NativeTouchEvent>) => {
    if (!props.onPress) return
    props.onPress(ev)
  }

  const spreadProps = { ...props, onPress: null }

  return (
    <StyledTouchableOpacity onPress={onPress} disabled={props.disabled}>
      <StyledView testID="ButtonAtom" {...spreadProps}>
        <StyledText textColor={props.textColor} flat={props.flat}>
          {props.title}
        </StyledText>
      </StyledView>
    </StyledTouchableOpacity>
  )
}

const StyledTouchableOpacity = styled.TouchableOpacity`
  flex: 1;
  margin: 12px;
`

const StyledView = styled.View<CustomProps>`
  padding: 16px 32px;
  background-color: ${props => {
    if (props.flat) return 'transparent'
    return props.color || theme.colors.secondary
  }};
  align-items: center;
  border-radius: 50px;
  justify-content: center;
`

const StyledText = styled(Text)<CustomProps>`
  color: ${props => {
    if (props.flat) return theme.colors.secondary
    return props.textColor || 'black'
  }};
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  font-family: 'RobotoSlab_700Bold';
  text-transform: none;
`

export default ButtonAtom
